import { getCookie, eraseCookie } from "./cookieHelper";
import { API_URL, BASE_URL } from "../constants";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export function isEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }
  return true;
}

function sprintf() {
  var regex = /%%|%(?:(\d+)\$)?((?:[-+#0 ]|'[\s\S])*)(\d+)?(?:\.(\d*))?([\s\S])/g;
  var args = arguments;
  var i = 0;
  var format = args[i++];

  var _pad = function (str, len, chr, leftJustify) {
    if (!chr) {
      chr = " ";
    }
    var padding =
      str.length >= len
        ? ""
        : new Array((1 + len - str.length) >>> 0).join(chr);
    return leftJustify ? str + padding : padding + str;
  };

  var justify = function (value, prefix, leftJustify, minWidth, padChar) {
    var diff = minWidth - value.length;
    if (diff > 0) {
      // when padding with zeros
      // on the left side
      // keep sign (+ or -) in front
      if (!leftJustify && padChar === "0") {
        value = [
          value.slice(0, prefix.length),
          _pad("", diff, "0", true),
          value.slice(prefix.length),
        ].join("");
      } else {
        value = _pad(value, minWidth, padChar, leftJustify);
      }
    }
    return value;
  };

  var _formatBaseX = function (
    value,
    base,
    leftJustify,
    minWidth,
    precision,
    padChar
  ) {
    // Note: casts negative numbers to positive ones
    var number = value >>> 0;
    value = _pad(number.toString(base), precision || 0, "0", false);
    return justify(value, "", leftJustify, minWidth, padChar);
  };

  // _formatString()
  var _formatString = function (
    value,
    leftJustify,
    minWidth,
    precision,
    customPadChar
  ) {
    if (precision !== null && precision !== undefined) {
      value = value.slice(0, precision);
    }
    return justify(value, "", leftJustify, minWidth, customPadChar);
  };

  // doFormat()
  var doFormat = function (
    substring,
    argIndex,
    modifiers,
    minWidth,
    precision,
    specifier
  ) {
    var number, prefix, method, textTransform, value;

    if (substring === "%%") {
      return "%";
    }

    // parse modifiers
    var padChar = " "; // pad with spaces by default
    var leftJustify = false;
    var positiveNumberPrefix = "";
    var j, l;

    for (j = 0, l = modifiers.length; j < l; j++) {
      // eslint-disable-next-line default-case
      switch (modifiers.charAt(j)) {
        case " ":
        case "0":
          padChar = modifiers.charAt(j);
          break;
        case "+":
          positiveNumberPrefix = "+";
          break;
        case "-":
          leftJustify = true;
          break;
        case "'":
          if (j + 1 < l) {
            padChar = modifiers.charAt(j + 1);
            j++;
          }
          break;
      }
    }

    if (!minWidth) {
      minWidth = 0;
    } else {
      minWidth = +minWidth;
    }

    if (!isFinite(minWidth)) {
      throw new Error("Width must be finite");
    }

    if (!precision) {
      precision =
        specifier === "d" ? 0 : "fFeE".indexOf(specifier) > -1 ? 6 : undefined;
    } else {
      precision = +precision;
    }

    if (argIndex && +argIndex === 0) {
      throw new Error("Argument number must be greater than zero");
    }

    if (argIndex && +argIndex >= args.length) {
      throw new Error("Too few arguments");
    }

    value = argIndex ? args[+argIndex] : args[i++];

    switch (specifier) {
      case "%":
        return "%";
      case "s":
        return _formatString(
          value + "",
          leftJustify,
          minWidth,
          precision,
          padChar
        );
      case "c":
        return _formatString(
          String.fromCharCode(+value),
          leftJustify,
          minWidth,
          precision,
          padChar
        );
      case "b":
        return _formatBaseX(
          value,
          2,
          leftJustify,
          minWidth,
          precision,
          padChar
        );
      case "o":
        return _formatBaseX(
          value,
          8,
          leftJustify,
          minWidth,
          precision,
          padChar
        );
      case "x":
        return _formatBaseX(
          value,
          16,
          leftJustify,
          minWidth,
          precision,
          padChar
        );
      case "X":
        return _formatBaseX(
          value,
          16,
          leftJustify,
          minWidth,
          precision,
          padChar
        ).toUpperCase();
      case "u":
        return _formatBaseX(
          value,
          10,
          leftJustify,
          minWidth,
          precision,
          padChar
        );
      case "i":
      case "d":
        number = +value || 0;
        // Plain Math.round doesn't just truncate
        number = Math.round(number - (number % 1));
        prefix = number < 0 ? "-" : positiveNumberPrefix;
        value = prefix + _pad(String(Math.abs(number)), precision, "0", false);

        if (leftJustify && padChar === "0") {
          // can't right-pad 0s on integers
          padChar = " ";
        }
        return justify(value, prefix, leftJustify, minWidth, padChar);
      case "e":
      case "E":
      case "f": // @todo: Should handle locales (as per setlocale)
      case "F":
      case "g":
      case "G":
        number = +value;
        prefix = number < 0 ? "-" : positiveNumberPrefix;
        method = ["toExponential", "toFixed", "toPrecision"][
          "efg".indexOf(specifier.toLowerCase())
        ];
        textTransform = ["toString", "toUpperCase"][
          "eEfFgG".indexOf(specifier) % 2
        ];
        value = prefix + Math.abs(number)[method](precision);
        return justify(value, prefix, leftJustify, minWidth, padChar)[
          textTransform
        ]();
      default:
        // unknown specifier, consume that char and return empty
        return "";
    }
  };

  try {
    return format.replace(regex, doFormat);
  } catch (err) {
    return false;
  }
}

export function getFormattedDate(date) {
  date = new Date(date);
  let y = date.getFullYear();
  let m = sprintf("%02d", date.getMonth() + 1);
  let d = sprintf("%02d", date.getDate());
  return [y, m, d].join("-");
}

export function newAccessTokenUrl() {
  var refresh_token = getCookie("refresh_token");
  if (refresh_token == null) {
    return "";
  } else {
    var newAccessTokenUrl =
      API_URL +
      "oauth/token?refresh_token=" +
      refresh_token +
      "&grant_type=refresh_token";
  }
  return newAccessTokenUrl;
}

export function generateErrorString(errors) {
  var finaldata = "";
  for (const property in errors) {
    var error = errors[property][0].split(" ");
    error.shift();
    error.splice(0, 0, property.toUpperCase());
    finaldata += error.join(" ") + "\n";
  }
  alert(finaldata);
}

export function logout() {
  eraseCookie("access_token");
  eraseCookie("token_type");
  eraseCookie("refresh_token");
  eraseCookie("expires_in");
  eraseCookie("permission");
  eraseCookie("username");
  window.location = BASE_URL;
}

export const exportToCSV = (csvData, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  var wss = XLSX.utils.aoa_to_sheet([["Name", "Contact", "Header"]]);
  const ws = XLSX.utils.sheet_add_json(wss, csvData);

  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};
export function autoDissaperAction() {
  setTimeout(() => window.location.reload(), 2000)
}

export function isEmptyString(e) {
  switch (e) {
    case "":
    case 0:
    case "0":
    case null:
    case false:
    case typeof e == "undefined":
      return true;
    default:
      return false;
  }
}
